import React from 'react'
import Text from '@component/Text/Text'

const LivePolicyEnglish = () => {
    return (
        <div className={'text-body1 text-gray02 dark:text-dark_gray02 px-[30px]'}>
            <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>League of Traders Live Policy</Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>Article 1 (Purpose)</Text>
            <Text className={'mt-[10px]'}>
                The purpose of this policy is to outline the rules and guidelines that users must follow to ensure the
                smooth and safe operation of the real-time chat service (hereinafter referred to as &quot;Live&quot;)
                provided by League of Traders (hereinafter referred to as &quot;the Service&quot;).
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                Article 2 (Eligibility for Using Live)
            </Text>
            <Text className={'mt-[10px]'}>
                Only users who have registered and agreed to the Terms of Service may use the Live feature, which is
                intended for the exchange of trading information including stocks, forex, cryptocurrencies, and more.
                The Live feature must not be used for any other purposes.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                Article 3 (Prohibited Actions)
            </Text>
            <Text className={'mt-[10px]'}>The following actions are strictly prohibited in Live:</Text>
            <Text className={'mt-[10px]'}>
                ① <strong>Spreading False Information:</strong> Intentionally distributing false or unverified
                information related to trading.
                <br />② <strong>Advertising and Promotion:</strong> Promoting or advertising investment products,
                services, websites, or social media accounts without permission.
                <br />③ <strong>Defamation and Personal Attacks:</strong> Defaming, insulting, or attacking another user
                or third party. 행위.
                <br />④ <strong>Illegal Activities:</strong> Engaging in discussions or providing information related to
                illegal trading activities or any other unlawful actions.
                <br />⑤ <strong>Fraudulent Activities:</strong> Making fraudulent statements or inducing others to
                engage in private transactions for financial gain.
                <br />⑥ <strong>Sharing Personal Information:</strong> Collecting or distributing another person’s
                personal information without consent.
                <br />⑦ <strong>Spam and Flooding:</strong> Sending repetitive messages, excessive use of emojis, or
                otherwise disrupting the flow of conversation.
            </Text>

            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                Article 4 (Restrictions and Sanctions)
            </Text>
            <Text className={'mt-[10px]'}>
                ① <strong>Warnings:</strong> Users who violate this policy may receive warnings, and repeated warnings
                will result in more severe penalties.
                <br />② <strong>Temporary Suspension:</strong> Continued violations may lead to a temporary suspension
                of access to Live.
                <br />③ <strong>Permanent Ban:</strong> Serious violations (e.g., fraud, spreading false information)
                may result in a permanent ban from Live without prior warning.
                <br />④ <strong>Legal Action:</strong> Any actions that violate the law may result in legal action being
                taken against the user.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>Article 5 (Live Monitoring)</Text>
            <Text className={'mt-[10px]'}>
                The Service reserves the right to monitor all conversations occurring in Live to ensure compliance with
                this policy. If violations are detected, immediate action may be taken against the offending user.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>Article 6 (Disclaimer)</Text>
            <Text className={'mt-[10px]'}>
                League of Traders is not responsible for any damages resulting from the exchange of trading information
                between users and does not guarantee the accuracy of any information shared in Live. Users are solely
                responsible for their own trading decisions and actions.
            </Text>
            <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>Article 7 (Policy Changes)</Text>
            <Text className={'mt-[10px]'}>
                This policy is subject to change as needed, and any changes will be announced through official service
                notices. Users are responsible for staying informed of and adhering to the updated policy.
            </Text>
        </div>
    )
}
export default LivePolicyEnglish
